export const TIMEZONE_OPTIONS = [
  { value: "UTC", label: "UTC (UTC+0)" },
  { value: "Africa/Abidjan", label: "Africa/Abidjan (UTC+0)" },
  { value: "Africa/Accra", label: "Africa/Accra (UTC+0)" },
  { value: "Africa/Bamako", label: "Africa/Bamako (UTC+0)" },
  { value: "Africa/Conakry", label: "Africa/Conakry (UTC+0)" },
  { value: "Africa/Dakar", label: "Africa/Dakar (UTC+0)" },
  { value: "Africa/Lome", label: "Africa/Lomé (UTC+0)" },
  {
    value: "Africa/Ouagadougou",
    label: "Africa/Ouagadougou (UTC+0)",
  },
  { value: "Africa/Cotonou", label: "Africa/Cotonou (UTC+1)" },
  { value: "Africa/Douala", label: "Africa/Douala (UTC+1)" },
  { value: "Africa/Kinshasa", label: "Africa/Kinshasa (UTC+1)" },
  { value: "Africa/Lagos", label: "Africa/Lagos (UTC+1)" },
  { value: "Africa/Niamey", label: "Africa/Niamey (UTC+1)" },
  {
    value: "Africa/Johannesburg",
    label: "Africa/Johannesburg (UTC+2)",
  },
  { value: "Africa/Nairobi", label: "Africa/Nairobi (UTC+3)" },
];

export const normalizeTimezone = (timezone) =>
  typeof timezone === "string" ? timezone.trim() : "";

export const getTimezoneOptions = (currentTimezone) => {
  const normalizedTimezone = normalizeTimezone(currentTimezone);

  if (
    !normalizedTimezone ||
    TIMEZONE_OPTIONS.some((option) => option.value === normalizedTimezone)
  ) {
    return TIMEZONE_OPTIONS;
  }

  return [
    { value: normalizedTimezone, label: normalizedTimezone },
    ...TIMEZONE_OPTIONS,
  ];
};
